import { AxiosRequestConfig } from "axios";
import { instanceConexao } from "services/axiosServices";

/**
 * @function postSugestao
 * @param {Object} params - parâmetros.
 * @param {number} params.tipoSugestao - enum do tipo da sugestão.
 * @param {string} params.sugestao - texto da sugestão.
 * @param {string} params.authToken - token de autenticação do usuário.
 * @returns {Promise<any>} - retorna confirmação da request.
 */
export const postSugestao = async (params: {
  tipoSugestao: number | null;
  sugestao: string;
  authToken: string;
}): Promise<any> => {
  const url = "api/Sugestoes";

  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };

  const response = await instanceConexao.post(url, parameters, config);
  return response?.data;
};
